import React from 'react';
import { API_URL } from '../lib/api';

// AuthScreen is the unauthenticated landing page that prompts the user to connect
// their Clio account.
export const AuthScreen: React.FC = () => (
  <div className="auth-container" style={{
    background: 'linear-gradient(135deg, #090d16 0%, #111827 50%, #1e1b4b 100%)',
    color: '#fff',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px',
    fontFamily: 'var(--body)',
    position: 'relative',
    boxSizing: 'border-box',
    width: '100vw',
    overflow: 'hidden'
  }}>
    {/* Glow Effects */}
    <div style={{ position: 'absolute', top: '10%', left: '15%', width: '400px', height: '400px', background: 'radial-gradient(circle, rgba(37,99,235,0.15) 0%, rgba(0,0,0,0) 70%)', pointerEvents: 'none' }}></div>
    <div style={{ position: 'absolute', bottom: '10%', right: '15%', width: '400px', height: '400px', background: 'radial-gradient(circle, rgba(124,58,237,0.15) 0%, rgba(0,0,0,0) 70%)', pointerEvents: 'none' }}></div>

    <div style={{
      width: '100%',
      maxWidth: '460px',
      background: 'rgba(22, 32, 46, 0.75)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      borderRadius: '16px',
      padding: 'clamp(28px, 7vw, 44px)',
      boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
      backdropFilter: 'blur(16px)',
      textAlign: 'center',
      zIndex: 10,
      boxSizing: 'border-box'
    }}>
      <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '64px', height: '64px', borderRadius: '16px', background: 'linear-gradient(135deg, var(--primary) 0%, #7c3aed 100%)', marginBottom: '24px', boxShadow: '0 8px 24px rgba(37, 87, 214, 0.3)' }}>
        <span style={{ fontSize: '32px' }}>⚖️</span>
      </div>

      <h1 style={{ fontFamily: 'var(--g)', fontWeight: 700, fontSize: '30px', lineHeight: 1.2, color: '#fff', letterSpacing: '-0.02em', marginBottom: '10px' }}>Lattice</h1>
      <div style={{ color: '#7dd3fc', fontFamily: 'var(--g)', fontSize: '13px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '26px' }}>Litigation Workbench</div>

      <p style={{ color: '#c3cedd', fontSize: '16px', lineHeight: 1.65, marginBottom: '34px' }}>
        Unlock case insights, visual proof graphs, and automated deadline tracking. Connect your Clio Manage account to authorize access.
      </p>

      <button
        onClick={() => {
          // Identity is established server-side via the OAuth handshake and a
          // session cookie; no client-held user id is passed.
          window.location.href = `${API_URL}/api/v1/auth/login`;
        }}
        style={{
          width: '100%',
          background: 'linear-gradient(90deg, var(--primary) 0%, #4f46e5 100%)',
          color: '#fff',
          fontFamily: 'var(--g)',
          fontWeight: 600,
          minHeight: '50px',
          fontSize: '16px',
          padding: '14px 18px',
          borderRadius: '10px',
          border: 'none',
          boxShadow: '0 4px 14px rgba(37, 87, 214, 0.35)',
          cursor: 'pointer',
          transition: 'transform 0.15s, filter 0.15s'
        }}
        onMouseEnter={e => e.currentTarget.style.filter = 'brightness(1.1)'}
        onMouseLeave={e => e.currentTarget.style.filter = 'brightness(1)'}
      >
        Authorize &amp; Connect Clio
      </button>
    </div>
  </div>
);
